import moment from "moment";

export const QUICK_SELECT_OPTIONS: {
  value: "previousPeriod" | "samePeriodPriorYear";
  label: string;
  relativeDate: () => moment.Moment;
}[] = [
  {
    value: "previousPeriod",
    label: "Previous period",
    relativeDate: () => moment().tz(moment.tz.guess()),
  },
  {
    value: "samePeriodPriorYear",
    label: "Same period, prior year",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(1, "year"),
  },
];
